import { setViewportDimensions } from 'actions/appStateActions';
import { debounce } from 'utils/utils';

export const initializeWindowResizeListener = (store, theWindow, theScreen) => {
  function handleWindowResize() {
    const viewportDetails = {
      width: theScreen.width < theWindow.innerWidth ? theScreen.width : theWindow.innerWidth,
      height: theWindow.innerHeight,
    };

    const mobileBreakpoint = viewportDetails.width <= 760;
    const isAndroid = /Android/.test(window.navigator.userAgent);
    const isMobileBreakpoint = mobileBreakpoint || isAndroid;

    store.dispatch(setViewportDimensions(viewportDetails, isMobileBreakpoint));
  }

  handleWindowResize();
  const debouncedResizeHandler = debounce(handleWindowResize, 150);
  theWindow.addEventListener('resize', debouncedResizeHandler);
};



/** WEBPACK FOOTER **
 ** ./src/initializeWindowResizeListener.js
 **/